import AuditEditLocationForm from './AuditEditLocationForm';

export default AuditEditLocationForm;
